import { useEditStore } from '../../hooks';
import { TaskRegistrationModalView } from '../../components/TaskRegistrationModalView';

export const TaskEditModal = () => {
  const editStore = useEditStore();

  return <TaskRegistrationModalView {...editStore} />;
};
